import { render, staticRenderFns } from "./Directories.vue?vue&type=template&id=d3776f06&scoped=true"
import script from "./Directories.vue?vue&type=script&setup=true&lang=js"
export * from "./Directories.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Directories.vue?vue&type=style&index=0&id=d3776f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3776f06",
  null
  
)

export default component.exports